import { Typography } from "@mui/material";
import { type FieldProps, useRecordContext } from "react-admin";
import get from "lodash/get";
import { nationalities } from "i18n-nationality/langs/de.json";

export function NationalityField(props: { source: string; emptyText?: string } & FieldProps) {
  const { source, emptyText } = props;
  const record = useRecordContext(props);
  if (!record) return null;
  const value = get(record, source);
  const nationality =
    typeof value === "string" && value in nationalities
      ? nationalities[value as keyof typeof nationalities]
      : undefined;

  return (
    <Typography component="span" variant="body2">
      {nationality ?? emptyText ?? "-"}
    </Typography>
  );
}
